export class FeatureFunctionalityBuilder {
  constructor() {
    this.config = {};
  }
  getConfig() {
    return this.config;
  }
  mergeIntoConfig(prop, itemsToAdd) {
    if (!this.config[prop]) this.config[prop] = [];
    this.config[prop].push(...itemsToAdd);
  }
}